export let SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["MEDIUM"] = "medium";
  return SIZE_OPTIONS;
}({});